module.exports = __webpack_public_path__ + "static/media/button-marketing@2x.d9690786.png";